import { FC } from "react";
import { useTranslation } from "react-i18next";

import { EVOLUTION_OF_ENERGY_CONSUMPTION_AND_ENERGY_PRICES_CHART_DATA_KEYS } from "../EvolutionOfEnergyConsumptionAndEnergyPrices.const";

import { EvolutionOfEnergyConsumptionAndEnergyPricesLineChartToolTipProps } from "./EvolutionOfEnergyConsumptionAndEnergyPricesLineChartToolTip.type";

const EvolutionOfEnergyConsumptionAndEnergyPricesLineChartToolTip: FC<EvolutionOfEnergyConsumptionAndEnergyPricesLineChartToolTipProps> = (props) => {
	const { t } = useTranslation();

	const { active, payload } = props;

	if (!active || !payload || !payload.length) {
		return null;
	}

	return (
		<div className="p-3 m-0 bg-white border border-primary">
			<p className="font-bold">{props.label}</p>
			<ul>
				{payload.map((data) => {
					const dataKey = EVOLUTION_OF_ENERGY_CONSUMPTION_AND_ENERGY_PRICES_CHART_DATA_KEYS.find((key) => key.name === data?.name);

					return (
						<li key={data?.dataKey} style={{ color: data?.color }}>
							{t(dataKey?.translation || data?.name)}: {data?.value}
						</li>
					);
				})}
			</ul>
		</div>
	);
};

export { EvolutionOfEnergyConsumptionAndEnergyPricesLineChartToolTip };